import type { TenantRole, UserRole } from "@nexys/user-management-client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select.js";

export interface UserRoleSelectProps {
  value: UserRole;
  onChange: (next: UserRole) => void;
  disabled?: boolean;
  /** Restrict assignable roles — defaults to user/useradmin/superadmin. */
  options?: ReadonlyArray<UserRole>;
}

const DEFAULT_USER_ROLES: ReadonlyArray<UserRole> = ["user", "useradmin", "superadmin"];

export const UserRoleSelect = ({
  value,
  onChange,
  disabled,
  options = DEFAULT_USER_ROLES,
}: UserRoleSelectProps) => (
  <Select
    value={value}
    onValueChange={(v) => onChange(v as UserRole)}
    disabled={disabled}
  >
    <SelectTrigger className="h-8 w-[10.5rem]">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {options.map((r) => (
        <SelectItem key={r} value={r} className="capitalize">
          {r}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export interface TenantRoleSelectProps {
  value: TenantRole;
  onChange: (next: TenantRole) => void;
  disabled?: boolean;
  options?: ReadonlyArray<TenantRole>;
}

const DEFAULT_TENANT_ROLES: ReadonlyArray<TenantRole> = ["member", "admin", "owner"];

export const TenantRoleSelect = ({
  value,
  onChange,
  disabled,
  options = DEFAULT_TENANT_ROLES,
}: TenantRoleSelectProps) => (
  <Select
    value={value}
    onValueChange={(v) => onChange(v as TenantRole)}
    disabled={disabled}
  >
    <SelectTrigger className="h-8 w-[10.5rem]">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {options.map((r) => (
        <SelectItem key={r} value={r} className="capitalize">
          {r}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
